import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";var _excluded = ["validation"];function ownKeys(object, enumerableOnly) {var keys = _Object$keys(object);if (_Object$getOwnPropertySymbols) {var symbols = _Object$getOwnPropertySymbols(object);enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {return _Object$getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));});}return target;}import _Object$freeze from "@babel/runtime-corejs3/core-js-stable/object/freeze";import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";import React from 'react';
import uniqid from 'uniqid';
import CheckboxEntity from "../../components/dynamicFormElements/CheckboxEntity";
import QuestionEntity from "../../components/dynamicFormElements/QuestionEntity";
import TextEntity from "../../components/dynamicFormElements/TextEntity";
import InputTextInputOption from "../../components/dynamicFormElements/InputTextInputOption";
import SelectInputOption from "../../components/dynamicFormElements/SelectInputOption";
import RadioInputOption from "../../components/dynamicFormElements/RadioInputOption";
import SICSelectInputOption from "../../components/dynamicFormElements/SICSelectInputOption";












import BCQuestionEntity from "../../components/dynamicFormElements/BC_QuestionEntity";
import ContributionOption from "../../components/dynamicFormElements/ContributionOption";
import CQuestionEntity from "../../components/dynamicFormElements/C_QuestionEntity";
import ZipCodeOption from "../../components/dynamicFormElements/ZipCodeOption";
import DateOfBirthOption from "../../components/dynamicFormElements/DateOfBirthOption";
import NestedQuestionEntity from "../../components/dynamicFormElements/NestedQuestionEntity";
import TextAreaOption from "../../components/dynamicFormElements/TextAreaOption";







import { DynamicFormControl } from "./DynamicFormControl";
import { CustomFieldControl } from "./CustomFieldControl";

export var INPUT_OPTIONS_SIZES = _Object$freeze({
  extraSmall: '22%',
  small: '29%',
  medium: '38%',
  large: '65%'
});

export var INPUT_OPTIONS_HEIGHT = _Object$freeze({
  small: '4.3rem',
  medium: '8.6rem',
  large: '12.9rem'
});






var INITIAL_VALUES_FOR_CUSTOM_COMPONENT =




_Object$freeze({
  STRING: '',
  BOOLEAN: false,
  NUMBER: 0,
  NULL: null,
  ARRAY: [],
  OBJECT: {}
});

// Renders questions inputOptions, required formController to be set up.
export function renderInputOptions(
inputOption,
formController)
{var _inputOption$properti, _inputOption$properti2, _inputOption$properti3, _inputOption$properti4, _inputOption$properti5, _inputOption$properti6, _inputOption$properti7, _inputOption$properti8, _inputOption$properti9, _inputOption$properti10, _inputOption$properti11, _inputOption$properti12, _inputOption$properti13, _inputOption$properti14, _inputOption$properti15, _inputOption$properti16, _inputOption$properti17, _inputOption$properti18, _inputOption$properti19, _inputOption$properti20, _inputOption$properti21, _inputOption$properti22, _formControl$value, _inputOption$properti27, _inputOption$properti28, _inputOption$properti29, _inputOption$properti30, _inputOption$properti31, _inputOption$properti32, _formControl$value2, _inputOption$properti33, _inputOption$properti34, _inputOption$properti35, _inputOption$properti36, _inputOption$properti37, _inputOption$properti38, _inputOption$properti39, _inputOption$properti40, _inputOption$properti41, _inputOption$properti42;
  var formControl = formController.fields[inputOption.id];
  switch (inputOption.type) {
    case 'INPUT':
      return /*#__PURE__*/(
        React.createElement(InputTextInputOption, {
          value: String(formControl.value),
          onChange: formController.onFieldChange,
          key: inputOption.id,
          inputType: (_inputOption$properti = inputOption.properties) === null || _inputOption$properti === void 0 ? void 0 : _inputOption$properti.inputType,
          name: inputOption.id,
          label: inputOption.displayValue,
          width: (_inputOption$properti2 = inputOption.properties) === null || _inputOption$properti2 === void 0 ? void 0 : _inputOption$properti2.width,
          autocompletePattern: (_inputOption$properti3 = inputOption.properties) === null || _inputOption$properti3 === void 0 ? void 0 : _inputOption$properti3.autocompletePattern,
          htmlType: (_inputOption$properti4 = inputOption.properties) === null || _inputOption$properti4 === void 0 ? void 0 : _inputOption$properti4.htmlType,
          disabled:
          (formControl === null || formControl === void 0 ? void 0 : formControl.disabled) ||
          formController.notAvailableByUserRoles(inputOption.roleAvailability || []),

          validationPassed: !formControl.unpassedValidationMsg,
          validationMessage: formControl.unpassedValidationMsg || '',
          additionalOptions: {
            guidelines: (_inputOption$properti5 = inputOption.properties) === null || _inputOption$properti5 === void 0 ? void 0 : _inputOption$properti5.guidelines,
            showGuidelinesByDefault: (_inputOption$properti6 = inputOption.properties) === null || _inputOption$properti6 === void 0 ? void 0 : _inputOption$properti6.showGuidelinesByDefault,
            contributionType: (_inputOption$properti7 = inputOption.properties) === null || _inputOption$properti7 === void 0 ? void 0 : _inputOption$properti7.contributionType,
            contributionInterval: (_inputOption$properti8 = inputOption.properties) === null || _inputOption$properti8 === void 0 ? void 0 : _inputOption$properti8.contributionInterval
          } }));


    case 'BC_INPUT':
      return /*#__PURE__*/(
        React.createElement(InputTextInputOption, {
          value: String(formControl.value),
          onChange: formController.onFieldChange,
          key: inputOption.id,
          name: inputOption.id,
          label: inputOption.displayValue,
          width: (_inputOption$properti9 = inputOption.properties) === null || _inputOption$properti9 === void 0 ? void 0 : _inputOption$properti9.width,
          autocompletePattern: (_inputOption$properti10 = inputOption.properties) === null || _inputOption$properti10 === void 0 ? void 0 : _inputOption$properti10.autocompletePattern,
          htmlType: (_inputOption$properti11 = inputOption.properties) === null || _inputOption$properti11 === void 0 ? void 0 : _inputOption$properti11.htmlType,
          disabled:
          (formControl === null || formControl === void 0 ? void 0 : formControl.disabled) ||
          formController.notAvailableByUserRoles(inputOption.roleAvailability || []),

          validationPassed: !formControl.unpassedValidationMsg,
          validationMessage: formControl.unpassedValidationMsg || '',
          additionalOptions: {
            guidelines: (_inputOption$properti12 = inputOption.properties) === null || _inputOption$properti12 === void 0 ? void 0 : _inputOption$properti12.guidelines,
            showGuidelinesByDefault: (_inputOption$properti13 = inputOption.properties) === null || _inputOption$properti13 === void 0 ? void 0 : _inputOption$properti13.showGuidelinesByDefault,
            contributionType: (_inputOption$properti14 = inputOption.properties) === null || _inputOption$properti14 === void 0 ? void 0 : _inputOption$properti14.contributionType,
            contributionInterval: (_inputOption$properti15 = inputOption.properties) === null || _inputOption$properti15 === void 0 ? void 0 : _inputOption$properti15.contributionInterval
          } }));


    case 'DOB':
      return /*#__PURE__*/(
        React.createElement(DateOfBirthOption, {
          value: String(formControl.value),
          onChange: formController.onFieldChange,
          key: inputOption.id,
          name: inputOption.id,
          label: inputOption.displayValue,
          width: (_inputOption$properti16 = inputOption.properties) === null || _inputOption$properti16 === void 0 ? void 0 : _inputOption$properti16.width,
          autocompletePattern: (_inputOption$properti17 = inputOption.properties) === null || _inputOption$properti17 === void 0 ? void 0 : _inputOption$properti17.autocompletePattern,
          htmlType: (_inputOption$properti18 = inputOption.properties) === null || _inputOption$properti18 === void 0 ? void 0 : _inputOption$properti18.htmlType,
          disabled: formControl === null || formControl === void 0 ? void 0 : formControl.disabled,
          validationPassed: !formControl.unpassedValidationMsg,
          validationMessage: formControl.unpassedValidationMsg || '',
          additionalOptions: {
            guidelines: (_inputOption$properti19 = inputOption.properties) === null || _inputOption$properti19 === void 0 ? void 0 : _inputOption$properti19.guidelines,
            showGuidelinesByDefault: (_inputOption$properti20 = inputOption.properties) === null || _inputOption$properti20 === void 0 ? void 0 : _inputOption$properti20.showGuidelinesByDefault
          },
          minAge: ((_inputOption$properti21 = inputOption.properties) === null || _inputOption$properti21 === void 0 ? void 0 : _inputOption$properti21.minAge) || 0,
          maxAge: ((_inputOption$properti22 = inputOption.properties) === null || _inputOption$properti22 === void 0 ? void 0 : _inputOption$properti22.maxAge) || 120 }));



    case 'SELECT':{var _inputOption$properti23;
        var options = filterOptions(inputOption, formController);
        resetOptionValue(options, formControl);
        setOneAndOnlyOptionValue(options, formController, inputOption.id);
        return /*#__PURE__*/(
          React.createElement(SelectInputOption, {
            key: inputOption.id,
            value: String(formControl.value),
            name: inputOption.id,
            onChange: formController.onFieldChange,
            options: options,
            disabled:
            (formControl === null || formControl === void 0 ? void 0 : formControl.disabled) ||
            options.length === 0 ||
            formController.notAvailableByUserRoles(inputOption.roleAvailability || []),

            width: (_inputOption$properti23 = inputOption.properties) === null || _inputOption$properti23 === void 0 ? void 0 : _inputOption$properti23.width,
            validationPassed: !formControl.unpassedValidationMsg,
            validationMessage: formControl.unpassedValidationMsg || '',
            label: inputOption.displayValue }));


      }
    case 'BC_SELECT':{var _inputOption$properti24, _inputOption$properti25, _inputOption$properti26;
        var _options = filterOptions(inputOption, formController);
        resetOptionValue(_options, formControl);
        setOneAndOnlyOptionValue(_options, formController, inputOption.id);
        return /*#__PURE__*/(
          React.createElement(SelectInputOption, {
            key: inputOption.id,
            value: String(formControl.value),
            name: inputOption.id,
            onChange: formController.onFieldChange,
            options: _options,
            disabled:
            (formControl === null || formControl === void 0 ? void 0 : formControl.disabled) ||
            _options.length === 0 ||
            formController.notAvailableByUserRoles(inputOption.roleAvailability || []),

            width: (_inputOption$properti24 = inputOption.properties) === null || _inputOption$properti24 === void 0 ? void 0 : _inputOption$properti24.width,
            validationPassed: !formControl.unpassedValidationMsg,
            validationMessage: formControl.unpassedValidationMsg || '',
            guidelines: (_inputOption$properti25 = inputOption.properties) === null || _inputOption$properti25 === void 0 ? void 0 : _inputOption$properti25.guidelines,
            showGuidelinesByDefault: (_inputOption$properti26 = inputOption.properties) === null || _inputOption$properti26 === void 0 ? void 0 : _inputOption$properti26.showGuidelinesByDefault,
            label: inputOption.displayValue }));


      }
    case 'RADIO':
      return /*#__PURE__*/(
        React.createElement(RadioInputOption, {
          label: inputOption.displayValue,
          id: uniqid(),
          key: uniqid() // This because of repeating ids in radio buttons, and I don't wont to rewrite the whole switch..case for the sake of it.
          , value: inputOption.value.toString(),
          name: inputOption.id,
          checked: inputOption.value.toString() === ((_formControl$value = formControl.value) === null || _formControl$value === void 0 ? void 0 : _formControl$value.toString()),
          onChange: formController.onFieldChange,
          disabled:
          (formControl === null || formControl === void 0 ? void 0 : formControl.disabled) ||
          formController.notAvailableByUserRoles(inputOption.roleAvailability || []),

          validationPassed: !formControl.unpassedValidationMsg,
          validationMessage: formControl.unpassedValidationMsg || '',
          guidelines: (_inputOption$properti27 = inputOption.properties) === null || _inputOption$properti27 === void 0 ? void 0 : _inputOption$properti27.guidelines,
          showGuidelinesByDefault: (_inputOption$properti28 = inputOption.properties) === null || _inputOption$properti28 === void 0 ? void 0 : _inputOption$properti28.showGuidelinesByDefault }));


    case 'SIC':
      return /*#__PURE__*/(
        React.createElement(SICSelectInputOption, {
          onUpdateValCallback: function onUpdateValCallback(sicCodes) {var _context, _context2;
            formController.onFieldUpdate('sic2', _trimInstanceProperty(_context = sicCodes.sic2.split('-')[0]).call(_context));
            formController.onFieldUpdate('sic4', _trimInstanceProperty(_context2 = sicCodes.sic4.split('-')[0]).call(_context2));
          },
          key: "sic4",
          validationPassed: !formControl.unpassedValidationMsg,
          validationMessage: formControl.unpassedValidationMsg || '',
          width: (_inputOption$properti29 = inputOption.properties) === null || _inputOption$properti29 === void 0 ? void 0 : _inputOption$properti29.width,
          disabled:
          formControl.disabled ||
          formController.notAvailableByUserRoles(inputOption.roleAvailability || []),

          defaultSic2: String(formController.fields.sic2.value),
          defaultSic4: String(formController.fields.sic4.value) }));


    case 'BC_SIC':
      return /*#__PURE__*/(
        React.createElement(SICSelectInputOption, {
          onUpdateValCallback: function onUpdateValCallback(sicCodes) {var _context3, _context4;
            formController.onFieldUpdate('sic2', _trimInstanceProperty(_context3 = sicCodes.sic2.split('-')[0]).call(_context3));
            formController.onFieldUpdate('sic4', _trimInstanceProperty(_context4 = sicCodes.sic4.split('-')[0]).call(_context4));
          },
          key: "sic4",
          validationPassed: !formControl.unpassedValidationMsg,
          validationMessage: formControl.unpassedValidationMsg || '',
          width: (_inputOption$properti30 = inputOption.properties) === null || _inputOption$properti30 === void 0 ? void 0 : _inputOption$properti30.width,
          fullWidth: true,
          disabled:
          formControl.disabled ||
          formController.notAvailableByUserRoles(inputOption.roleAvailability || []),

          defaultSic2: String(formController.fields.sic2.value),
          defaultSic4: String(formController.fields.sic4.value),
          guidelines: (_inputOption$properti31 = inputOption.properties) === null || _inputOption$properti31 === void 0 ? void 0 : _inputOption$properti31.guidelines,
          showGuidelinesByDefault: (_inputOption$properti32 = inputOption.properties) === null || _inputOption$properti32 === void 0 ? void 0 : _inputOption$properti32.showGuidelinesByDefault }));


    case 'CONTRIBUTION':
      return /*#__PURE__*/(
        React.createElement(ContributionOption, {
          key: uniqid(),
          isBtnActive: (inputOption === null || inputOption === void 0 ? void 0 : inputOption.value) === ((_formControl$value2 = formControl.value) === null || _formControl$value2 === void 0 ? void 0 : _formControl$value2.toString()),
          disclaimer: inputOption === null || inputOption === void 0 ? void 0 : inputOption.disclaimer,
          guidelines: inputOption === null || inputOption === void 0 ? void 0 : inputOption.guidelines,
          showGuidelinesByDefault: inputOption === null || inputOption === void 0 ? void 0 : inputOption.showGuidelinesByDefault,
          onClick: function onClick() {
            formController.onContributionButtonClick(inputOption.value, inputOption.id);
          } },

        inputOption.properties.buttonText));


    case 'ZIP_CODE':
      return /*#__PURE__*/(
        React.createElement(ZipCodeOption, {
          key: inputOption.id,
          onUpdateValCallback: function onUpdateValCallback(_ref) {var zipId = _ref.zipId,state = _ref.state,selectedCounty = _ref.selectedCounty;
            formController.onFieldUpdate(inputOption.id, zipId);
            formController.onFieldUpdate("".concat(inputOption.id, "_state"), state);
            formController.onFieldUpdate("".concat(inputOption.id, "_county"), selectedCounty);
          },
          editable: (_inputOption$properti33 = inputOption.properties) === null || _inputOption$properti33 === void 0 ? void 0 : _inputOption$properti33.editable,
          disabled: (_inputOption$properti34 = inputOption.properties) === null || _inputOption$properti34 === void 0 ? void 0 : _inputOption$properti34.disabled,
          defaultZip:
          String(formController.fields[inputOption.id].value || '') || ((_inputOption$properti35 =
          inputOption.properties) === null || _inputOption$properti35 === void 0 ? void 0 : _inputOption$properti35.defaultZip),

          defaultState:
          String(formController.fields["".concat(inputOption.id, "_state")].value || '') || ((_inputOption$properti36 =
          inputOption.properties) === null || _inputOption$properti36 === void 0 ? void 0 : _inputOption$properti36.defaultState),

          defaultCounty:
          String(formController.fields["".concat(inputOption.id, "_county")].value || '') || ((_inputOption$properti37 =
          inputOption.properties) === null || _inputOption$properti37 === void 0 ? void 0 : _inputOption$properti37.defaultCounty),

          zipOptionName: inputOption.id,
          stateOptionName: "".concat(inputOption.id, "_state"),
          countyOptionName: "".concat(inputOption.id, "_county"),
          validationPassed: !formControl.unpassedValidationMsg,
          validationMessage: formControl.unpassedValidationMsg || '' }));


    case 'TEXT_AREA':
      return /*#__PURE__*/(
        React.createElement(TextAreaOption, {
          value: String(formControl.value),
          onChange: formController.onFieldChange,
          key: inputOption.id,
          name: inputOption.id,
          label: inputOption.displayValue,
          width: (_inputOption$properti38 = inputOption.properties) === null || _inputOption$properti38 === void 0 ? void 0 : _inputOption$properti38.width,
          height: (_inputOption$properti39 = inputOption.properties) === null || _inputOption$properti39 === void 0 ? void 0 : _inputOption$properti39.height,
          disabled:
          (formControl === null || formControl === void 0 ? void 0 : formControl.disabled) ||
          formController.notAvailableByUserRoles(inputOption.roleAvailability || []),

          autocompletePattern: (_inputOption$properti40 = inputOption.properties) === null || _inputOption$properti40 === void 0 ? void 0 : _inputOption$properti40.autocompletePattern,
          formGuidelines: {
            guidelines: (_inputOption$properti41 = inputOption.properties) === null || _inputOption$properti41 === void 0 ? void 0 : _inputOption$properti41.guidelines,
            showGuidelinesByDefault: (_inputOption$properti42 = inputOption.properties) === null || _inputOption$properti42 === void 0 ? void 0 : _inputOption$properti42.showGuidelinesByDefault
          },
          validationPassed: !formControl.unpassedValidationMsg,
          validationMessage: formControl.unpassedValidationMsg || '' }));


    default:
      return null;}

}

// Checks if there is at least one inputOption listed in this entity's showWhen rules, which value
// does not satisfy answerValues constraint in the corresponding showWhen rule, returns boolean.
export function shouldEntityBeRendered(
showWhenRules,
fields)
{
  return showWhenRules ?
  showWhenRules.every(function (showWhenRule) {var _fields$showWhenRule$, _context5;
    var value = String((_fields$showWhenRule$ = fields[showWhenRule.key]) === null || _fields$showWhenRule$ === void 0 ? void 0 : _fields$showWhenRule$.value);
    return _includesInstanceProperty(_context5 = showWhenRule.answerValues).call(_context5, value);
  }) :
  true;
}

// Renders all the entities listed in the FormObject layout property.
export function renderEntity(
entity,
formController,
customFormEntities)
{var _entity$properties, _entity$properties2, _entity$properties3;
  switch (entity.type) {
    case 'CHECKBOX':
      return shouldEntityBeRendered(entity.showWhen, formController.fields) ? /*#__PURE__*/
      React.createElement(CheckboxEntity, {
        label: entity.label,
        name: entity.key,
        key: entity.key,
        currentValue: String(formController.fields[entity.key].value) === 'true',
        onChange: formController.onCheckboxChange,
        highlightColor: (_entity$properties = entity.properties) === null || _entity$properties === void 0 ? void 0 : _entity$properties.highlightColor,
        validationPassed: !formController.fields[entity.key].unpassedValidationMsg,
        validationMessage: formController.fields[entity.key].unpassedValidationMsg || '',
        guidelines: (_entity$properties2 = entity.properties) === null || _entity$properties2 === void 0 ? void 0 : _entity$properties2.guidelines,
        showGuidelinesByDefault: (_entity$properties3 = entity.properties) === null || _entity$properties3 === void 0 ? void 0 : _entity$properties3.showGuidelinesByDefault }) :

      null;
    case 'QUESTION':{var _entity$properties4, _context6;
        return shouldEntityBeRendered(entity.showWhen, formController.fields) ? /*#__PURE__*/
        React.createElement(QuestionEntity, {
          label: entity.label,
          disclaimer: entity.disclaimer,
          key: entity.key,
          layout: (_entity$properties4 = entity.properties) === null || _entity$properties4 === void 0 ? void 0 : _entity$properties4.layout },

        _mapInstanceProperty(_context6 = entity.inputOptions).call(_context6, function (inputOption) {return (
            renderInputOptions(inputOption, formController));})) :


        null;
      }
    case 'NESTED_QUESTION':{var _context7;
        return shouldEntityBeRendered(entity.showWhen, formController.fields) ? /*#__PURE__*/
        React.createElement(NestedQuestionEntity, { label: entity.label, disclaimer: entity.disclaimer, key: entity.key },
        _mapInstanceProperty(_context7 = entity.inputOptions).call(_context7, function (inputOption) {return (
            renderInputOptions(inputOption, formController));})) :


        null;
      }
    case 'BC_QUESTION':{var _entity$properties5, _entity$properties6, _entity$properties7, _context8;
        return shouldEntityBeRendered(entity.showWhen, formController.fields) ? /*#__PURE__*/
        React.createElement(BCQuestionEntity, {
          label: entity.label,
          guidelines: (_entity$properties5 = entity.properties) === null || _entity$properties5 === void 0 ? void 0 : _entity$properties5.guidelines,
          showGuidelinesByDefault: (_entity$properties6 = entity.properties) === null || _entity$properties6 === void 0 ? void 0 : _entity$properties6.showGuidelinesByDefault,
          key: entity.key,
          layout: (_entity$properties7 = entity.properties) === null || _entity$properties7 === void 0 ? void 0 : _entity$properties7.layout },

        _mapInstanceProperty(_context8 = entity.inputOptions).call(_context8, function (inputOption) {return (
            renderInputOptions(inputOption, formController));})) :


        null;
      }
    case 'C_QUESTION':{var _entity$properties8, _entity$properties9, _entity$properties10, _context9;
        return shouldEntityBeRendered(entity.showWhen, formController.fields) ? /*#__PURE__*/
        React.createElement(CQuestionEntity, {
          label: entity === null || entity === void 0 ? void 0 : entity.label,
          disclaimer: entity === null || entity === void 0 ? void 0 : entity.disclaimer,
          guidelines: entity === null || entity === void 0 ? void 0 : (_entity$properties8 = entity.properties) === null || _entity$properties8 === void 0 ? void 0 : _entity$properties8.guidelines,
          showGuidelinesByDefault: entity === null || entity === void 0 ? void 0 : (_entity$properties9 = entity.properties) === null || _entity$properties9 === void 0 ? void 0 : _entity$properties9.showGuidelinesByDefault,
          key: entity.key,
          layout: (_entity$properties10 = entity.properties) === null || _entity$properties10 === void 0 ? void 0 : _entity$properties10.layout },

        _mapInstanceProperty(_context9 = entity.inputOptions).call(_context9, function (inputOption) {return (
            renderInputOptions(inputOption, formController));})) :


        null;
      }
    case 'TEXT':
      return shouldEntityBeRendered(entity.showWhen, formController.fields) ? /*#__PURE__*/
      React.createElement(TextEntity, {
        key: uniqid() // Refactor that if you have an opportunity
        , label: entity.label,
        prefix: entity.prefix }) : /*#__PURE__*/


      React.createElement(React.Fragment, null);

    case 'CUSTOM':
      return shouldEntityBeRendered(entity.showWhen, formController.fields) &&
      customFormEntities &&
      customFormEntities[entity.key] ?
      customFormEntities[entity.key] :
      null;

    default:
      return null;}

}

// Checks if there is an existing master object, and if so adds a new serve enable-when object. If
// there is no such master returns a new array with a passed enableWhen rule as a single serve in that array.
export function createServesForMaster(
newServeId,
existingServes,
dependencyAnswerValues)
{var _context10;
  var newServe = {
    key: newServeId,
    answerValues: dependencyAnswerValues
  };
  return existingServes ? _concatInstanceProperty(_context10 = []).call(_context10, _toConsumableArray(existingServes), [newServe]) : [newServe];
}

// Creates a new enableMastersObject based on passed dependencies (showWhen or enableWhen) and the
// existing enableMastersObject.
export function createNewEnableMastersObject(
newServeId,
depFields,
existingEnableMastersObject)
{
  var newEnableMastersObject = _objectSpread({}, existingEnableMastersObject);
  depFields.forEach(function (depField) {
    var existingServesOfMaster = existingEnableMastersObject[depField.key];
    newEnableMastersObject[depField.key] = createServesForMaster(
    newServeId,
    existingServesOfMaster,
    depField.answerValues);

  });
  return newEnableMastersObject;
}

// Constructs enableMastersObject, which is used for enabling/disabling inputOptions in the controller,
// and showing/hiding questions in the dynamic form layout.
export function createEnableMastersObject(formSections) {
  var enableMastersObject = {};
  formSections.forEach(function (section) {
    // For each entity with showWhen rule - creates a serveObject with the entity key as its key and this showWhen
    // rule answerValues, and adds it to the corresponding master in enableMastersObject (master is each showWhen
    // object 'key' property) or creates a new master key.
    section.layout.forEach(function (entity) {
      // Exclude static entities from the process
      if (entity.type === 'TEXT') {
        return;
      }
      if (entity.showWhen && entity.key) {
        // Adds entities keys as serves for showing/hiding them.
        enableMastersObject = createNewEnableMastersObject(
        entity.key,
        entity.showWhen,
        enableMastersObject);

      }
      if (
      entity.type === 'QUESTION' ||
      entity.type === 'BC_QUESTION' ||
      entity.type === 'C_QUESTION' ||
      entity.type === 'NESTED_QUESTION')
      {
        // Creates servesObject for every inputOption in the entity
        entity.inputOptions.forEach(function (inputOption) {
          // All fields that this inputOption is dependent on.
          // If entity has showWhen object, then it's inputOption also should has it's serveObject at the same
          // master as the entity, because when the entity is hidden the inputOption should be disabled (for all
          // it's validations to pass).
          if (entity.showWhen) {
            enableMastersObject = createNewEnableMastersObject(
            inputOption.id,
            entity.showWhen,
            enableMastersObject);

          }
          // Adds inputOption enableWhen rules to the dependenciesList.
          if (inputOption.enableWhen) {
            enableMastersObject = createNewEnableMastersObject(
            inputOption.id,
            inputOption.enableWhen,
            enableMastersObject);

          }
        });
      }
    });
  });
  return enableMastersObject;
}

// Returns newly constructed DynamicFormControl based on the passed
// inputOption parameters.
export function createDynamicFormFieldControl(
inputOption,
entityShowWhen)
{var _inputOption$properti43, _inputOption$enableWh;
  var dynamicFormControlParams = {};
  var defaultValue = '';
  if ((_inputOption$properti43 = inputOption.properties) !== null && _inputOption$properti43 !== void 0 && _inputOption$properti43.optional) {
    dynamicFormControlParams.optional = true;
  }
  if (!!(inputOption !== null && inputOption !== void 0 && (_inputOption$enableWh = inputOption.enableWhen) !== null && _inputOption$enableWh !== void 0 && _inputOption$enableWh.length) || !!(entityShowWhen !== null && entityShowWhen !== void 0 && entityShowWhen.length)) {
    dynamicFormControlParams.disabled = true;
  }
  if (inputOption.validation) {
    dynamicFormControlParams.validations = inputOption.validation;
  }
  if (inputOption.defaultValue) {
    defaultValue = inputOption.defaultValue;
  }

  return new DynamicFormControl(defaultValue, dynamicFormControlParams);
}

// Constructs dynamicFormFields object which is used as fields for creating formController.
export function createDynamicFormFieldsObject(formSections) {
  var dynamicFormFields = {};
  var defaultValue = 'false';

  formSections.forEach(function (section) {
    section.layout.forEach(function (entity) {
      if (
      entity.type === 'QUESTION' ||
      entity.type === 'BC_QUESTION' ||
      entity.type === 'C_QUESTION' ||
      entity.type === 'NESTED_QUESTION')
      {
        // Construct FormInput with the passed parameters for every passed inputOption
        entity.inputOptions.forEach(function (inputOption) {
          // Do not recreate a record in the form fields object if there is
          // one already created (for radio buttons). Do not create record
          // if this inputOption does not have a proper id.
          if (inputOption.id && !dynamicFormFields[inputOption.id]) {
            if (inputOption.type === 'SIC' || inputOption.type === 'BC_SIC') {
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              var validation = inputOption.validation,restOptions = _objectWithoutProperties(inputOption, _excluded);
              dynamicFormFields.sic2 = createDynamicFormFieldControl(restOptions, entity.showWhen);
              dynamicFormFields.sic4 = createDynamicFormFieldControl(inputOption, entity.showWhen);
            }
            if (inputOption.type === 'ZIP_CODE') {
              dynamicFormFields[inputOption.id] = createDynamicFormFieldControl(
              inputOption,
              entity.showWhen);

              dynamicFormFields["".concat(inputOption.id, "_state")] = createDynamicFormFieldControl(
              inputOption,
              entity.showWhen);

              dynamicFormFields["".concat(inputOption.id, "_county")] = createDynamicFormFieldControl(_objectSpread(_objectSpread({},
              inputOption), {}, { defaultValue: '' }),
              entity.showWhen);

            } else {
              dynamicFormFields[inputOption.id] = createDynamicFormFieldControl(
              inputOption,
              entity.showWhen);

            }
          }
        });
      }
      if (entity.type === 'CHECKBOX') {var _entity$properties11, _entity$properties13, _entity$properties14;
        if ((_entity$properties11 = entity.properties) !== null && _entity$properties11 !== void 0 && _entity$properties11.defaultValue) {var _entity$properties12;
          defaultValue = (_entity$properties12 = entity.properties) === null || _entity$properties12 === void 0 ? void 0 : _entity$properties12.defaultValue;
        }

        dynamicFormFields[entity.key] = new DynamicFormControl(defaultValue, {
          optional: !((_entity$properties13 = entity.properties) !== null && _entity$properties13 !== void 0 && _entity$properties13.required),
          validations: (_entity$properties14 = entity.properties) !== null && _entity$properties14 !== void 0 && _entity$properties14.required ?
          [{ regex: 'true', errorMessage: 'Should be selected' }] :
          []
        });
      }
    });
  });
  return dynamicFormFields;
}

// Constructs customDynamicFormFields object for all the 'CUSTOM' entities.
export function createCustomDynamicFormFields(
formSections)
{
  var customDynamicFormFields = {};
  formSections.forEach(function (section) {var _context11;
    _filterInstanceProperty(_context11 = section.layout).call(_context11, function (entity) {return entity.type === 'CUSTOM';}).forEach(
    function (entity) {var _entity$properties15, _entity$properties16, _entity$properties17;
      customDynamicFormFields[entity.key] = new CustomFieldControl({
        initialValue:
        (_entity$properties15 = entity.properties) !== null && _entity$properties15 !== void 0 && _entity$properties15.valueType &&
        Object.prototype.hasOwnProperty.call(
        INITIAL_VALUES_FOR_CUSTOM_COMPONENT, (_entity$properties16 =
        entity.properties) === null || _entity$properties16 === void 0 ? void 0 : _entity$properties16.valueType) ?

        INITIAL_VALUES_FOR_CUSTOM_COMPONENT[entity.properties.valueType] :
        INITIAL_VALUES_FOR_CUSTOM_COMPONENT.STRING,

        initialValidationStatus: !((_entity$properties17 = entity.properties) !== null && _entity$properties17 !== void 0 && _entity$properties17.required)
      });
    });

  });
  return customDynamicFormFields;
}







export function createDynamicFormControllerParamsFromJSON(
formObject)
{
  formObject.sections.forEach(function (section) {
    section.layout.forEach(function (entity) {var _context12;
      // eslint-disable-next-line no-param-reassign
      entity.showWhen = _concatInstanceProperty(_context12 = []).call(_context12, _toConsumableArray(section.showWhen || []), _toConsumableArray(entity.showWhen || []));
    });
  });
  return {
    enableMastersObject: createEnableMastersObject(formObject.sections),
    fields: createDynamicFormFieldsObject(formObject.sections),
    customDynamicFields: createCustomDynamicFormFields(formObject.sections)
  };
}

function filterOptions(
inputOption,
formController)
{var _context13, _context14;
  return _mapInstanceProperty(_context13 = _filterInstanceProperty(_context14 = inputOption.options).call(_context14,
  function (option) {var _option$enableWhen, _option$enableWhen$fi;
    if (!option.enableWhen) return true; // if there r no rules on option pass it
    var amountOfPassed =
    ((_option$enableWhen = option.enableWhen) === null || _option$enableWhen === void 0 ? void 0 : (_option$enableWhen$fi = _filterInstanceProperty(_option$enableWhen).call(_option$enableWhen, function (when) {var _context15;return (
        _includesInstanceProperty(_context15 = when.answerValues).call(_context15, formController.fields[when.key].value));})) === null || _option$enableWhen$fi === void 0 ? void 0 : _option$enableWhen$fi.
    length) || 0; // calculates how many rules passed (by reviewing answers in the form)
    return amountOfPassed === option.enableWhen.length; // compare passed rules with all amount - all rules should pass for one option
  })).call(_context13,
  function (option) {return {
      value: option.value,
      label: option.displayValue
    };});
}

function resetOptionValue(options, formControl) {var _context16;
  if (!_includesInstanceProperty(_context16 = _mapInstanceProperty(options).call(options, function (option) {return option.value;})).call(_context16, String(formControl.value))) {
    formControl.overrideValue(formControl.initialValue);
  }
}

function setOneAndOnlyOptionValue(
options,
formController,
id)
{
  if (options.length === 1) {
    formController.onFieldUpdate(id, options[0].value);
  }
}
//# sourceMappingURL=dynamicFormsHelpers.js.map